// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eU6T","top":"styles_top__34KHt"};